import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from "react-toastify";
import { useGetBlogs } from "../../queries/blog";
import { useGetChallengeCategoriesList } from "../../queries/challenge";
import BlogListTable from './components/BlogListTable';
import { useEffect, useState } from 'react';
import { ActionButton } from '../../components/Forms/ActionButton';
import { useGetActiveOrganiser, useGetAllUsers } from '../../queries/user';
import { useNavigate } from 'react-router-dom';
import AttachedProductImpactModal from '../../components/AttachedProductImpactModal';

const BlogList = () => {

    const navigate = useNavigate();

    // const [selectedTab, setSelectedTab] = useState('blogs-list'); // ['blogs-list', 'user-blog-submission']

    const { data, isPending, isError, refetch } = useGetBlogs('admin');

    const { data: users, isPending: isUserPending } = useGetAllUsers(toast);
    const { data: organiserList, isPending: isOrganiserListPending } = useGetActiveOrganiser();
    const { data: challengeCategoryList, isLoading: isChallengeCategoryPending } = useGetChallengeCategoriesList();

    const [filteredData, setFilteredData] = useState(!isPending && data);

    const [filters, setFilters] = useState({
        fromDate: '',
        toDate: '',
        title: '',
        category: '',
        status: false,
        user: '',
    });

    const [showImpactModal, setShowImpactModal] = useState(false);
    const [selectedBlog, setSelectedBlog] = useState(null);

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({ ...prev, [name]: value }));
    };

    const handleSearch = (e) => {
        e.preventDefault();
        let filtered = Array.isArray(data) ? data : [];

        if (filters.fromDate) {
            filtered = filtered.filter((blog) => new Date(blog.createdAt) >= new Date(filters.fromDate));
        }
        if (filters.toDate) {
            filtered = filtered.filter((blog) => new Date(blog.createdAt) <= new Date(filters.toDate + 'T23:59:59'));
        }
        if (filters.title) {
            filtered = filtered.filter((blog) =>
                blog.title.toLowerCase().includes(filters.title.toLowerCase())
            );
        }
        if (filters.category) {
            filtered = filtered.filter((blog) => blog?.category?._id === filters.category);
        }
        if (filters.status) {
            filtered = filtered.filter((blog) => 
                filters.status === 'active' ? blog.active === true : blog.active === false
            );
        }
        if (filters.user) {
            filtered = filtered.filter((blog) => 
                blog?.createdByUser?._id === filters.user ||
                blog?.createdByNgo?._id === filters.user ||
                blog?.createdByCompany?._id === filters.user
            );
        }
        
        setFilteredData(filtered);
    }

    const handleViewImpact = (blog) => {
        setSelectedBlog(blog);
        setShowImpactModal(true);
    };

    // useEffect(() => {
    //     refetch(selectedTab === 'blogs-list' ? 'admin' : 'user');
    // }, [selectedTab]);

    useEffect(() => {
        if (Array.isArray(data)) {
            setFilteredData(data);
        } else {
            setFilteredData([]);
        }
    }, [data]);

    if (isPending || isUserPending || isOrganiserListPending || isChallengeCategoryPending) {
        return (
            <div className="flex justify-center items-center w-full h-96">
                <h1 className="text-xl text-gray-400">Loading...</h1>
            </div>
        );
    }
    // if (isError) {
    //     return (
    //         <div className="flex justify-center items-center w-full h-96">
    //             <h1 className="text-xl text-gray-400">Error fetching data!</h1>
    //         </div>
    //     );
    // }
    return (
        <main className="flex flex-col text-base font-semibold text-gray-900 rounded-none">

            {/* Tabs */}
            {/* <div className='my-4 flex gap-2'>
                <button
                    className={`font-bold text-base flex-grow rounded-md py-2 border-2 ${selectedTab === 'blogs-list' ? 'bg-white' : 'bg-navBtn'} ${selectedTab === 'blogs-list' ? 'border-primary' : 'border-navBtn'}`}
                    onClick={() => {
                        setSelectedTab('blogs-list');
                        refetch('admin');
                    }}
                >
                    Blog List</button>
                <button
                    className={`font-bold text-base flex-grow rounded-md py-2 border-2 ${selectedTab === 'user-blog-submission' ? 'bg-white' : 'bg-navBtn'} ${selectedTab === 'user-blog-submission' ? 'border-primary' : 'border-navBtn'}`}
                    onClick={() => {
                        setSelectedTab('user-blog-submission');
                        refetch('user');
                    }}
                >
                    User Blog Submission</button>
            </div> */}

            {/* Filters */}
            <form
                className="flex flex-col pt-5 w-full bg-white rounded-md shadow-[0px_0px_25px_rgba(94,92,154,0.1)] "
                onSubmit={handleSearch}
            >
                <div className='flex items-center justify-between pr-5'>
                    <div className="flex gap-1.5 items-start my-auto text-base whitespace-nowrap ml-5">
                        <img
                            loading="lazy"
                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/4dd39feef0ff4934d9e2e86b8c7285d5d7532aeb26adcdc1e878d021439e2681?placeholderIfAbsent=true&apiKey=d62bea31e5c5472d8bb4326e92b00478"
                            alt=""
                            className="object-contain shrink-0 w-5 aspect-square"
                        />
                        <span className="self-stretch">Filters</span>
                        <img
                            loading="lazy"
                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/d18f51a0b2d597a302f55b77fc1071043eab5f274a1cc9e9b3fe3e2c97520a8c?placeholderIfAbsent=true&apiKey=d62bea31e5c5472d8bb4326e92b00478"
                            alt=""
                            className="object-contain shrink-0 aspect-square w-[18px]"
                        />
                    </div>
                    <ActionButton
                        variant={'reset'}
                        text={'Create New Blog'}
                        handleSubmit={() => navigate('/blogs/create-blog')}
                    />
                </div>
                <div className="flex flex-wrap gap-4 p-5">
                    <div className='flex gap-3 w-full'>
                        <div className="flex-col w-full">
                            <label htmlFor="fromDate" className="gap-1 self-stretch w-full text-gray-900 text-base">
                                From Date
                            </label>
                            <div className="flex gap-2.5 items-center px-4 py-2.5 mt-2.5 w-full whitespace-nowrap bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <input
                                    type="date"
                                    name="fromDate"
                                    value={filters.fromDate}
                                    onChange={handleFilterChange}
                                    className="w-full outline-none"
                                />
                            </div>
                        </div>
                        <div className="flex-col w-full">
                            <label htmlFor="toDate" className="gap-1 self-stretch w-full text-gray-900 text-base">
                                To Date
                            </label>
                            <div className="flex gap-2.5 items-center px-4 py-2.5 mt-2.5 w-full whitespace-nowrap bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <input
                                    type="date"
                                    name="toDate"
                                    value={filters.toDate}
                                    onChange={handleFilterChange}
                                    className="w-full outline-none"
                                />
                            </div>
                        </div>
                        <div className="flex-col w-full">
                            <label htmlFor="title" className="gap-1 self-stretch w-full text-gray-900 text-base">
                                Title
                            </label>
                            <div className="flex gap-2.5 items-center px-4 py-2.5 mt-2.5 w-full whitespace-nowrap bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <input
                                    type="text"
                                    name="title"
                                    value={filters.title}
                                    onChange={handleFilterChange}
                                    placeholder="Enter Blog Title"
                                    className='w-full outline-none focus:ring-0'
                                />
                            </div>
                        </div>
                    </div>
                    <div className='flex gap-3 w-full'>
                        <div className="flex-col w-full">
                            <label htmlFor="category" className="gap-1 self-stretch w-full text-gray-900 text-base">
                                Category
                            </label>
                            <div className="flex gap-2.5 items-center px-4 py-2.5 mt-2.5 w-full whitespace-nowrap bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <select
                                    name="category"
                                    value={filters.category}
                                    onChange={handleFilterChange}
                                    className="flex-1 shrink self-stretch my-auto basis-0 bg-transparent border-none outline-none text-base"
                                >
                                    <option value="">All Categories</option>
                                    {Array.isArray(challengeCategoryList) &&
                                        challengeCategoryList.map((category) => (
                                            <option key={category._id} value={category._id}>
                                                {category.name}
                                            </option>
                                        ))}
                                </select>
                            </div>
                        </div>
                        <div className="flex-col w-full">
                            <label htmlFor="status" className="gap-1 self-stretch w-full text-gray-900 text-base">
                                Status
                            </label>
                            <div className="flex gap-2.5 items-center px-4 py-2.5 mt-2.5 w-full whitespace-nowrap bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <select
                                    name="status"
                                    value={filters.status}
                                    onChange={handleFilterChange}
                                    className="flex-1 shrink self-stretch my-auto basis-0 bg-transparent border-none outline-none text-base"
                                >
                                    <option value="">All Status</option>
                                    <option value="active">Active</option>
                                    <option value="inactive">Inactive</option>
                                </select>
                            </div>
                        </div>
                        <div className="flex-col w-full">
                            <label htmlFor="user" className="gap-1 self-stretch w-full text-gray-900 text-base">
                                User
                            </label>
                            <div className="flex gap-2.5 items-center px-4 py-2.5 mt-2.5 w-full whitespace-nowrap bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <select
                                    name="user"
                                    value={filters.user}
                                    onChange={handleFilterChange}
                                    className="flex-1 shrink self-stretch my-auto basis-0 bg-transparent border-none outline-none text-base"
                                >
                                    <option value="">All Users</option>
                                    {Array.isArray(users) &&
                                        users.map((user) => (
                                            <option key={user._id} value={user._id}>
                                                {user.username}
                                            </option>
                                        ))}
                                    {Array.isArray(organiserList) &&
                                        organiserList.map((organiser) => (
                                            <option key={organiser._id} value={organiser._id}>
                                                {organiser.name}
                                            </option>
                                        ))}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Action Button */}
                <div className='flex gap-3 items-center justify-end p-5'>
                    <ActionButton
                        variant={'reset'}
                        text={'Reset'}
                        handleSubmit={() => {
                            setFilters({
                                fromDate: '',
                                toDate: '',
                                title: '',
                                category: '',
                                status: '',
                                user: '',
                            });
                            setFilteredData(data);
                        }}
                    />
                    <ActionButton
                        variant={'submit'}
                        text={'Search'}
                        handleSubmit={handleSearch}
                    />
                </div>

            </form>

            <section className="flex flex-col pt-5 w-full mt-5 bg-white rounded-md shadow-[0px_0px_25px_rgba(94,92,154,0.1)] max-md:max-w-full">
                <div className="flex flex-col pr-px pl-6 w-full max-md:pl-5 max-md:max-w-full">
                    <h1 className="self-start text-lg font-semibold">Blog List</h1>
                    <BlogListTable
                        data={Array.isArray(filteredData) ? filteredData : (Array.isArray(data) ? data : [])}
                        toast={toast}
                        onViewImpact={handleViewImpact}
                    />
                </div>
            </section>
            <ToastContainer
                position="top-right"
                autoClose={3000}
            />
            
            {/* Attached Product Impact Modal */}
            <AttachedProductImpactModal
                isOpen={showImpactModal}
                onClose={() => {
                    setShowImpactModal(false);
                    setSelectedBlog(null);
                }}
                item={selectedBlog}
                location="blog-details"
                contentType="blog"
            />
        </main>
    )
}

export default BlogList;